// Unauthorized.js
import React from 'react';
import { useNavigate,Link } from 'react-router-dom';
export default function Unauthorized() {
    const navigate=useNavigate()
    return (
        <div className='bg-gray-100 flex flex-col justify-between '>
            <h1>Unauthorized</h1>
            <p>You do not have permission to view this page.</p>
            <p>You either need to login or register</p>
            <p>Want to login</p>  <Link to="/loginUser" className=' hover:text-blue-500'>Login</Link>
            <p>Want to login</p>  <Link to="/registerUser" className='hover:text-blue-500'>registerUser</Link>
        </div>
    );
}
